const DEFAULT_SELECTORS = {
  USA: 'All USA Stores',
  CANADA: 'All Canada Stores',
};

export default DEFAULT_SELECTORS;
